import { Accordion } from '@/common/components/Accordion/Accordion';
import { Divider } from '@/common/components/Divider/Divider';
import { NavigationSteps } from '@/common/components/NavigationSteps/NavigationSteps';
import { Section } from '@/common/components/Section/Section';
import { Stack } from '@/common/components/Stack/Stack';

export const PlaygroundMiscellaneous = () => {
  return (
    <Stack gap="md">
      <Section title="NavigationSteps">
        <NavigationSteps
          steps={[
            { title: 'Step 1', description: 'Step 1 description' },
            {
              title: 'Step 2',
              description:
                'This is a description text for Step 2. Please follow the instructions carefully to complete this step.',
            },
            { title: 'Step 3', description: 'Step 3 description' },
            { title: 'Step 4', description: 'Step 4 description' },
          ]}
          currentStep={1}
        />
      </Section>
      <Divider />
      <Accordion.Root title="Accordion">
        <Accordion.Item
          question="When will this new insurance plan start?"
          answer="Banana olives olives broccoli bbq Philly burnt lovers dolor bacon. Roll Bianca lovers steak roll. Beef Hawaiian tossed sausage bbq. Bbq broccoli dolor lot cheese bell deep bbq fresh pork. Style wing mayo red tomatoes bacon mayo Chicago party party. Mayo roll personal ham party sausage chicken large bacon. Cheese meatball platter platter hand extra."
        />
        <Accordion.Item
          question="When will I start making these payments?"
          answer="Banana olives olives broccoli bbq Philly burnt lovers dolor bacon. Roll Bianca lovers steak roll. Beef Hawaiian tossed sausage bbq. Bbq broccoli dolor lot cheese bell deep bbq fresh pork. Style wing mayo red tomatoes bacon mayo Chicago party party. Mayo roll personal ham party sausage chicken large bacon. Cheese meatball platter platter hand extra."
        />
        <Accordion.Item
          question="What if I have any other questions later on?"
          answer="Banana olives olives broccoli bbq Philly burnt lovers dolor bacon. Roll Bianca lovers steak roll. Beef Hawaiian tossed sausage bbq. Bbq broccoli dolor lot cheese bell deep bbq fresh pork. Style wing mayo red tomatoes bacon mayo Chicago party party. Mayo roll personal ham party sausage chicken large bacon. Cheese meatball platter platter hand extra."
        />
      </Accordion.Root>
    </Stack>
  );
};
